export default (state, action) => {
  const { itemId } = action.payload;
  return { ...state, source: itemId };
};
